import settings from "./settings";
interface ConversationParams {
    chatId: string;
    question: string;
    agentId: string;
    patientName: string | null;
    coachName: string | null;
    date: string | null;
  }
  const { REACT_APP_BACKEND_URL } = settings;

  export async function conversationAPI(payload: ConversationParams, loginWithMicrosoft: () => void) {
    const token = localStorage.getItem('access_token');
        
    if (!token) {
        console.warn('No access token found, redirecting to login.');
        loginWithMicrosoft();  // Trigger login if no token is found
    }

    const url = `${REACT_APP_BACKEND_URL}/chat/chat`;
    const data = {
      query: payload.question,
      session_id: payload.chatId,
      agent_id: payload.agentId,
      patient_name: payload.patientName,
      coach_name: payload.coachName,
      call_date: payload.date,
    };
    return await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",        
        "Authorization": `Bearer ${token}`,  // Include the token in the Authorization header

      },
      body: JSON.stringify(data),
    }).then((response) => {
      return response;
    });
  }
  